import { useMemo } from 'react';

import useGet from 'lib/hooks/useGet';
import { UPB_VIEWER_BETA_ENRICHMENT_FUNNEL } from 'lib/networking/endpoints';

/**
 * useUPBBetaEnrichmentFunnel — fetches the 8-stage enrichment funnel data.
 *
 * Returns { data, loading, error, refetch }
 * data is an array of stage objects:
 *   [{ stage, key, label, description, count, pct_of_total,
 *      pct_of_gmv, drop_pct, kind, threshold }]
 */
function useUPBBetaEnrichmentFunnel({
  l1CategoryId,
  vendorId,
  thirdPartyTag,
  skuType,
  skip = false,
} = {}) {
  const params = useMemo(() => {
    const p = {};
    if (l1CategoryId) p.l1_category_id = l1CategoryId;
    if (vendorId) p.vendor_id = vendorId;
    if (thirdPartyTag) p.third_party_tag = thirdPartyTag;
    if (skuType) p.sku_type = skuType;
    return p;
  }, [l1CategoryId, vendorId, thirdPartyTag, skuType]);

  return useGet(UPB_VIEWER_BETA_ENRICHMENT_FUNNEL, params, skip);
}

export default useUPBBetaEnrichmentFunnel;
